import styled from 'styled-components';
import FadeInUp from '../animation/FadeInUp';
import BlackMainImage from '../../assets/images/black-main.png';
import BlackImage1 from '../../assets/images/black_1.png';
import BlackImage2 from '../../assets/images/black_2.png';
import BlackImage3 from '../../assets/images/black_3.png';
import BlackImage4 from '../../assets/images/black_4.png';
import BlackImage5 from '../../assets/images/black_5.png';

const images = [BlackImage1, BlackImage2];

const BlackSection = () => {
  return (
    <StyledSection>
      <img src={BlackMainImage} alt="" />
      <FadeInUp>
        <h2>We're getting married</h2>
      </FadeInUp>
      <FadeInUp>
        <StyledUl>
          {images.map((image, index) => (
            <li key={index}>
              <img src={image} alt="" />
            </li>
          ))}
        </StyledUl>
      </FadeInUp>
      <FadeInUp>
        <StyledBorderUl>
          <li>
            <img src={BlackImage3} alt="" />
            <p>
              2025.06.01
              <br />
              SUN 11:00
            </p>
          </li>
          <li>
            <img src={BlackImage4} alt="" />
            <p>
              YOUNGJUN
              <br />
              YUJIN
            </p>
          </li>
        </StyledBorderUl>
      </FadeInUp>
      <StyledLastSection>
        <FadeInUp>
          <h3>
            Please join us
            <br />
            for the wedding
          </h3>
          <img src={BlackImage5} alt="" />
        </FadeInUp>
      </StyledLastSection>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  background-color: var(--surface);
  font-family: var(--dearly-loved);
  color: var(--pink);
  overflow: hidden;

  h2 {
    margin: 2rem 0;
    text-align: center;
    font-size: 2rem;
    line-height: 3rem;
  }
`;

const StyledUl = styled.ul`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;

  & > li {
    width: 16rem;
  }
`;

const StyledBorderUl = styled.ul`
  display: flex;
  justify-content: space-between;
  gap: 3rem;
  // font-family: var(--nanum);

  li {
    display: flex;
    flex-direction: column;
    width: 20rem;

    img {
      width: 100%;
      border-radius: 0 3rem 3rem 0;
    }

    p {
      padding: 1.4rem 1rem;
    }

    &:nth-child(even) {
      flex-direction: column-reverse;
      width: 16rem;
      text-align: right;
      padding-top: 9rem;

      img {
        border-radius: 3rem 0 0 3rem;
      }
    }
  }
`;

const StyledLastSection = styled.section`
  padding: 2rem 4.5rem 0;
  font-size: 2rem;
  line-height: 2.4rem;
  text-align: center;

  h3 {
    margin-bottom: 2rem;
  }

  img {
    max-width: 30rem;
    border-radius: 15rem 15rem 0 0;
  }
`;

export default BlackSection;
